import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Box, Typography, Popover, Table, TableBody, TableRow, TableCell, Button, TableContainer, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface IProps {
  tenantId: string;
  deviceName: string;
  placeholderUrl: string;
}

export interface ISettingsPopoverHandles {
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const SettingsPopover = forwardRef<ISettingsPopoverHandles, IProps>(({ tenantId, deviceName, placeholderUrl }, ref) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigateBack = () => {
    navigate('/');
  };

  useImperativeHandle(ref, () => ({
    handleClick,
  }));

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      style={{ marginTop: '-10px' }}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={2} p={2}>
        <TableContainer component={Paper} elevation={0}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row" style={{ borderBottom: "none" }}>
                  Tenant ID:
                </TableCell>
                <TableCell align="right" style={{ borderBottom: "none" }}>
                  {tenantId}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ borderBottom: "none" }}>
                  Device Name:
                </TableCell>
                <TableCell align="right" style={{ borderBottom: "none" }}>
                  {deviceName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" style={{ borderBottom: "none" }}>
                  Placeholder URL:
                </TableCell>
                <TableCell align="right" style={{ borderBottom: "none" }}>
                  {placeholderUrl || "Keine Platzhalter Url angegeben"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Button variant="outlined" color="primary" onClick={handleNavigateBack}>
          Neu Einrichten
        </Button>
      </Box>
    </Popover>
  );
});

export default SettingsPopover;
